"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EarlyOfferCreditStateDto = void 0;
class EarlyOfferCreditStateDto {
}
exports.EarlyOfferCreditStateDto = EarlyOfferCreditStateDto;
//# sourceMappingURL=early-offer-credit-state.dto.js.map